import styled from 'styled-components';
import { BLUE, BORDER, GREY_TEXT } from '../AnalyticsV2.styled';

export const SECTION_BACKGROUND = '#F7F8FA';

// A grey card holding the graph or the tiles, as in the design.
export const Section = styled.section`
  margin-top: 24px;
  padding: 16px 24px 24px;
  border-radius: 12px;
  background: ${SECTION_BACKGROUND};
`;

// Centred text or spinner in place of the page, the graph or the tiles.
export const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: ${({ $height }) => $height || 240}px;
  color: ${GREY_TEXT};
  font-size: 14px;
`;

export const LinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 15px;
  color: #1c1c1c;
  cursor: pointer;
  &:hover {
    color: ${BLUE};
  }
`;

export const OutlinedButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
  background: #ffffff;
  font: inherit;
  font-size: 15px;
  color: ${GREY_TEXT};
  cursor: pointer;
  &:hover {
    color: #1c1c1c;
  }
`;
